import * as $ from "jquery";

interface FacultyPerson {
    ID: number;
    Prefix: string;
    InProgress: boolean;
}

export class Faculty {
    people: Array<FacultyPerson>;
    $letters: JQuery;

    /* ---- FOOTER ---- */
    constructor(people: Array<FacultyPerson>) {
        const self = this;
        self.people = people;
        self.$letters = $("#prefixes .letter");

        /* Alphabetical Sorting Options */
        self.$letters.on("click", function () {
            const $active = $(this);
            const prefix = $active.html().replace(/^\s\s*/, "").replace(
                /\s\s*$/,
                "",
            );

            self.filterFaculty($active, prefix);
        });

        $("#prefixes .faculty-button").on("click", function () {
            self.unfilterFaculty();
        });
    }

    filterFaculty($active: JQuery, prefix: string) {
        // Updates active filter
        this.$letters.removeClass("active");
        $active.addClass("active");

        // Filters faculty list
        const faculty = this.people.filter((person) =>
            person.Prefix === prefix
        );
        this.getFaculty(faculty);
    }

    unfilterFaculty() {
        // Updates active filter
        this.$letters.removeClass("active");

        // Shows all faculty
        $("#faculty .person").show();
    }

    getFaculty(faculty: Array<FacultyPerson>) {
        const footnote = $("#facultyFootnote");

        $("#faculty .person").hide();

        let inProgress = false;

        for (let value of faculty) {
            const $container = $("#person" + value.ID);

            $container.show();

            if (value.InProgress) {
                inProgress = true;
            }
        }
        footnote.toggle(inProgress);
    }
}
